var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.BUSINESS_REPORT_STOCK_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "is-pagination": false,
          stripe: true,
          "is-list": "",
          "span-method": _vm.spanMethod,
          "show-summary": _vm.showSummary,
          "summary-method": _vm.summaryMethod,
          "row-class-name": _vm.rowClassName,
          "default-sort": _vm.defaultSort,
          "reset-data": _vm.resetData,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          "sort-change": _vm.sortChange,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessReportStockDeliver.deliveryTime"
                          ),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessReportStockDeliver.deliveryTime"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime = $$v
                            },
                            expression: "queryParamsTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessReportStockDeliver.warehouseIds"
                          ),
                          prop: "warehouseIds",
                        },
                      },
                      [
                        _c("BjSelectWarehouse", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessReportStockDeliver.warehouseIds"
                            ),
                            "type-code": ["logic"],
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryParams.warehouseIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "warehouseIds", $$v)
                            },
                            expression: "queryParams.warehouseIds",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessReportStockDeliver.logisticsCompanyIds"
                          ),
                          prop: "logisticsCompanyIds",
                        },
                      },
                      [
                        _c("BjSelectLogisticCompany", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessReportStockDeliver.logisticsCompanyIds"
                            ),
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryParams.logisticsCompanyIds,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "logisticsCompanyIds",
                                $$v
                              )
                            },
                            expression: "queryParams.logisticsCompanyIds",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c("BjRadioLov", {
                      attrs: {
                        "option-list": _vm.collectTypeOptions,
                        placeholder: _vm.$t("chooseText"),
                      },
                      model: {
                        value: _vm.queryParams.statsType,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "statsType", $$v)
                        },
                        expression: "queryParams.statsType",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm.queryParams.statsType === 1
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessReportStockDeliver.warehouseIds"
                        ),
                        prop: "warehouseName",
                        align: "center",
                      },
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessReportStockDeliver.logisticsCompanyIds"
                    ),
                    prop: "logisticsCompanyName",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.type
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessReportStockDeliver.subtotal"
                                    )
                                  )
                                ),
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(scope.row.logisticsCompanyName)),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessReportStockDeliver.shippingQty"),
                    prop: "shippingQty",
                    align: "center",
                    sortable: "custom",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessReportStockDeliver.packageQty"),
                    prop: "packageQty",
                    align: "center",
                    sortable: "custom",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessReportStockDeliver.goodsQty"),
                    prop: "goodsQty",
                    align: "center",
                    sortable: "custom",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessReportStockDeliver.postageTotal"),
                    prop: "postageTotal",
                    align: "center",
                    sortable: "custom",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }